import { render, staticRenderFns } from "./FilePickerActivator.vue?vue&type=template&id=423ae916&scoped=true&"
import script from "./FilePickerActivator.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FilePickerActivator.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./FilePickerActivator.vue?vue&type=style&index=0&id=423ae916&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423ae916",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('423ae916')) {
      api.createRecord('423ae916', component.options)
    } else {
      api.reload('423ae916', component.options)
    }
    module.hot.accept("./FilePickerActivator.vue?vue&type=template&id=423ae916&scoped=true&", function () {
      api.rerender('423ae916', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/appointment/uslugi/new/components/ServiceAppointmentForm/components/AttachedFiles/components/FilePickerActivator.vue"
export default component.exports